import { Route, Routes } from 'react-router-dom'

import { SurveysAccessLayout } from 'pages/surveys/layout/SurveysAccessLayout'
import { SurveysPageLayout } from 'pages/surveys/layout/SurveysPageLayout'
import { SurveysPage } from 'pages/surveys/ui/SurveysPage'
import { SurveysRoutes } from './type'

export const SurveysRouter = () => {
  return (
    <Routes>
      <Route element={<SurveysAccessLayout />}>
        <Route element={<SurveysPageLayout />}>
          <Route path={'/'} element={<SurveysPage />} />

          <Route path={`${SurveysRoutes.create}`} element={<div />} />
        </Route>
      </Route>
    </Routes>
  )
}
